<template>
  <div>
    <div class="queue-navbar-container">
      <Navbar v-if="!isDesktop" @desktopNavigate="navigateBackToMode" />
      <NavbarDesktop
        v-else
        :action="action"
        @onDiscardAction="emitClose()"
        @onConfirmAction="onActionConfirm"
      />
    </div>
    <div class="tables-loader" v-if="busy">
      <h2>
        <font-awesome-icon icon="spinner" spin />
        {{ $t("tables.loading") }}
      </h2>
      <p>{{ $t("tables.loading_text") }}</p>
    </div>
    <div class="modal-container" v-if="!busy">
      <div class="tables-container">
        <!-- <h3>{{ $t('choose_table.title') }}</h3> -->
        <div v-for="(block, index) in tablesUi">
          <small>{{ block.name }}</small>
          <div>
            <div class="table-blocks" v-for="(row, index) in block.rows" :key="index">
              <div
                v-for="(cell, index) in row"
                :class="getCellClasses(cell)"
                @click="selectTable(cell)"
                :key="index"
              >
                {{ cell.title }}
                <span class="table-amount" v-if="cell.amount > 0">{{ cell.amount }}</span>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <!-- <div class="confirm-button">
        <img src="/icons/btn-back.svg" @click="emitClose()" class="btn-back" />
        <small class="info" v-if="!action.selection">
          Оберіть стіл,
          <br />з яким хочете об'єднати поточний стіл.
        </small>
        <button
          v-if="action.selection"
          class="btn"
          :class="getBtnColor"
          @click="onActionConfirm()"
        >{{getCorrectBtnName}}</button>
      </div>-->
      <BottomNavbar v-if="!isDesktop" @cancel="emitClose">
        <template v-slot>
          <small class="info" v-if="!action.selection">
            {{ $t('tables.action_messages.merge_description') }}
          </small>

          <button
            v-if="action.selection"
            class="btn"
            :class="getBtnColor"
            @click="onActionConfirm()"
          >{{getCorrectBtnName}}</button>
        </template>
      </BottomNavbar>
    </div>

    <div class="hide-content" @click="tableModal = false" v-if="tableModal"></div>
    <div class="table-modal" v-if="tableModal">
      <!-- <div class="table-modal-close-block">
        <img src="/icons/del-red.svg" class="table-modal-close" @click="onModalClose" />
      </div>-->

      <div class="table-modal-title">
        <h3>{{ $t("tables.table_no") }}{{ selectedTable.title }}</h3>
        <h3>{{ selectedTable.hall }}</h3>
        <h5>{{ cafe.sections[selectedTable.section].name }}</h5>
      </div>

      <div class="table-modal-content">
        <div class="modal-data-present" v-if="selectedTable.amount > 0">
          <h3 class="table-modal-count">{{ formatModalAmount }}</h3>

          <div class="table-modal-actions">
            <!-- <button
              class="action-merge blue-btn"
              @click="onModalMergeChecks"
            >{{ $t('tables.actions.merge') }}</button>-->
            <button
              class="action-join-tables blue-btn"
              v-if="selectedTable.tables.length == 1"
              @click="onModalActionJoin"
            >{{ $t("tables.actions.join") }}</button>
            <button
              class="action-join-tables red-btn"
              v-if="selectedTable.tables.length > 1"
              @click="onModalActionDisjoin"
            >{{ $t("tables.actions.disjoin") }}</button>
            <button
              class="action-move green-btn"
              @click="onModalActionMove"
            >{{ $t("tables.actions.move") }}</button>
          </div>
        </div>
        <div class="modal-data-empty" v-if="selectedTable.amount === 0">
          <h3 class="table-modal-count">{{ $t("tables.table_empty") }}</h3>

          <button
            class="action-join-tables blue-btn"
            v-if="selectedTable.tables.length == 1"
            @click="onModalActionJoin"
          >{{ $t("tables.actions.join_empty") }}</button>

          <button
            class="action-join-tables red-btn"
            v-if="selectedTable.tables.length > 1"
            @click="onModalActionDisjoin"
          >{{ $t("tables.actions.disjoin") }}</button>
        </div>
      </div>
    </div>

    <MergeModal
      :orders="merge.orders"
      @cancel="onMergeCancel"
      @merge="onMergeConfirm"
      v-if="merge.active"
    />
  </div>
</template>

<style scoped>
* {
  padding: 0;
  margin: 0;
}
.modal-container {
  z-index: 1;
  position: fixed;
  left: 0;
  top: 5vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 3vh 0 15vh;
  background: #ededed;
  width: 100%;
  height: 100%;
}

.tables-container {
  width: 90%;
  margin: 0 auto;
}

.table-blocks {
  display: flex;
}

.block-name {
  font-size: 18px;
  line-height: 21px;
  color: #bcbcbc;
  display: block;
  margin-bottom: 11px;
}
small.info {
  display: block;
  text-align: center;
  font-size: 1.7vh;
  line-height: normal;
  padding: 0.5vh 0 0 0;
  color: #908f8d;
}

.block-table {
  position: relative;
  width: 26.7vw;
  height: 26.7vw;
  border-radius: 10px;
  border: 3px solid transparent;
  text-align: center;
  font-size: 3vh;
  line-height: 1.2;
  color: #ededed;
  margin: 0.8vh;
  font-weight: 550;
  background: #a4a3a1;
  vertical-align: middle;

  /* 
    I do not know flex really good,
    so I've just put center everywhere
   */
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.block-table:nth-child(3n + 3) {
  margin-right: 0;
}
.block-table:first-child {
  margin-left: 0;
}

small {
  color: #bcbcbc;
  font-size: 4.8vw;
  padding: 1.9vh 0;
  display: block;
}

.table-number {
  /* center this shit pls */
}

.table-modal-title h3 {
  padding: 0 !important;
}

.block-table-busy {
  background-color: #416293;
  color: white;
}

.block-table-selected {
  border: 3px solid #416293;
}
.block-table-move {
  border: 3px solid #129b81;
}

.block-table-locked {
  border: 3px solid #416293;
}

.hide-content {
  background: black;
  opacity: 0.5;
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 5;
}

.table-amount {
  background: #e2223b;
  font-size: 4vw;
  position: absolute;
  top: -0.6vw;
  right: -0.3vw;
  line-height: 1;
  padding: 0.3vh 2vw 0.4vh;
  border-radius: 5vh;
}

hr {
  width: 100vw;
  margin: 3.7vh 0 0 -7vw;
}

h3 {
  font-size: 6.4vw;
}

h5 {
  font-size: 4.3vw;
}

.table-modal {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  background: #ededed;
  text-align: center;
  transform: translateY(-50%);
  position: fixed;
  top: 50%;
  left: 5%;
  width: 90%;
  padding: 5.4vw;
  z-index: 15;
}

.confirm-button {
  background: #1d1d1d;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding: 1.3vh 3.2vh 2.6vh;
  z-index: 5;
  width: 100%;
  position: fixed;
  left: 0;
}
.btn-green {
  background: #129b81;
  border: none;
  float: right;
}

.btn-red {
  background: #e2223b;
}

.btn-back {
  background: #e2223b;
  color: white;
  width: 6.2vh;
  height: 6.2vh;
  border-radius: 5vh;
  border: none;
}

.btn-back img {
  margin: 0 -0.5vh auto;
  display: block;
}

.btn {
  height: auto;
  font-size: 2.3vh;
  width: 80%;
  line-height: normal;
  color: #ededed;
  box-shadow: 0px 4px 1px rgba(0, 0, 0, 0.25);
  border-radius: 5vh;
}

.table-modal-close-block {
  float: right;
}

.table-modal-close {
  box-shadow: 0px 1px 7px #dadada;
  background: #ededed;
  border-radius: 50%;
  padding: 10px;
  margin-top: -1.3vh;
  display: inline-block;
}

.table-modal-title {
  line-height: 0.8;
  text-align: left;
  color: #1d1d1b;
}

.table-modal-count {
  font-size: 4.4vh;
  color: #a4a3a1;
  margin: 3.7vh 0 1.5vh;
}

.action-join-tables,
.action-move,
.action-merge {
  box-shadow: 0px 4px 1px rgba(0, 0, 0, 0.25);
  border-radius: 25px;
  color: #ededed;
  margin-top: 2vh;
  font-weight: 400;
  font-size: 2vh;
  border: none;
  width: 100%;
  padding: 1.6vh 0;
}

.blue-btn {
  background: #416293;
}

.red-btn {
  background: #e2223b;
}

.green-btn {
  background: #129b81;
}

.action-title {
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;

  color: black;
}

.action-confirm {
  width: 100%;
  position: fixed;

  bottom: 20px;
  text-align: center;
}

.confirm-button {
  padding: 10px;
}

.tables-loader {
  text-align: center;
  margin-top: 10%;
}

.queue-navbar-container {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 2;
}

.tables-containers h3 {
  padding: 5.4vw 5.4vw 0;
}

.tables-containers {
  background: #ededed;
  top: 8vh;
  height: 90vh;
  overflow: hidden;
  position: relative;
}

@media screen and (min-width: 768px) {
  .hide-content {
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
  }

  .tables-grid {
    position: relative;
    width: 30%;
    padding-bottom: 5vh;
    max-height: 80vh;
  }
  hr {
    width: 100%;
    margin: 3vh 0 0;
  }

  .table-amount {
    width: 1.458vw;
    height: 1.389vw;
    font-size: 0.972vw;
    line-height: 1.111vw;
    padding: 0.139vw 0.417vw;
    border-radius: 0.556vw;
    margin: 0;
    top: 0.069vw;
    right: 0;
  }

  .tables-container {
    width: 97.5695vw;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }

  .tables-container div div {
    display: flex;
    padding-left: 1.38889vw;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .tables-container div small {
    padding: 0 1.38889vw;
    font-size: 1.25vw;
    line-height: 1.458vw;
    margin-top: 1.389vw;
    color: #464646;
  }
  .tables-container div hr {
    background: #908f8d;
  }

  .table-blocks .block-table {
    justify-content: center;
    width: 6.9449vw;
    height: 6.9449vw;
    margin: 0 1.04167vw 0 0;
    padding: 2.5vw 0;
    font-size: 1.66667vw;
    line-height: 1.66667vw;
  }

  .tables-container div div .table-blocks {
    padding: 0;
    margin-top: 1.042vw;
  }

  .tables-container h3 {
    display: none;
  }
  div.modal-container {
    top: 0;
    height: 100vh;
    overflow-y: scroll;
    padding: 9.722vw 0 1.389vw;
  }
  div.modal-container::-webkit-scrollbar {
    width: 0;
  }
  .confirm-button {
    display: none;
  }
  div.table-modal {
    width: 23.264vw;
    padding: 1.389vw;
    top: 50%;
    left: 38.333vw;
  }
  .table-modal-title h3 {
    font-size: 1.597vw;
    line-height: 1.806vw;
  }
  .table-modal-title h5 {
    font-size: 0.903vw;
    line-height: 1.042vw;
  }
  h3.table-modal-count {
    font-size: 2.5vw;
    line-height: 2.847vw;
    margin: 1.389vw 0;
  }
  .table-modal-close-block {
    display: none;
  }
  .action-join-tables {
    width: 20.486vw;
    height: 3.403vw;
    margin: 1.389vw 0 0 0;
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
  .action-merge.blue-btn {
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
  .action-move.green-btn {
    margin: 1.389vw 0 0 0;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
}
</style>

<script>
import Navbar from "@/components/Navbar.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";
import MergeModal from "@/components/modals/MergeModal.vue";

import BottomNavbar from "@/components/BottomNavbar.vue";

export default {
  data() {
    return {
      tableModal: false,
      selectedTable: null,
      clientWidth: 0,
      action: {
        present: false,
        type: null,
        target: null,
        selection: null,
      },

      merge: {
        active: false,
        orders: [],
      },
      busy: true,
    };
  },
  methods: {
    handleResize(event) {
      this.clientWidth = window.innerWidth;
    },
    fetchOrders() {
      this.busy = true;
      this.$store.dispatch("queue/fetchJoinedTables").then((ok) => {
        this.$store.dispatch("queue/fetchOrders").then((ok) => {
          this.busy = false;
        });
      });
    },
    getCellClasses(cell) {
      return {
        "block-table": true,
        "block-table-busy": cell.amount > 0,
        "block-table-selected":
          this.action.present && this.action.selection == cell,
        "block-table-move":
          this.action.type == "move" && this.action.selection == cell,
        "block-table-locked": this.action.present && this.action.target == cell,
      };
    },
    emitClose() {
      if (this.action.present) {
        this.resetAction();
        return;
      }

      this.$router.push("/orders");
    },
    selectTable(cell) {
      if (this.action.present) {
        if (this.action.type == "join") {
          if (cell.tables.length > 1) return;
        }
        if (this.action.target != cell) this.action.selection = cell;
        return;
      }

      this.selectedTable = cell;
      this.tableModal = true;
    },
    onModalClose() {
      this.tableModal = false;
    },

    onModalActionMove() {
      this.action.target = this.selectedTable;
      this.action.type = "move";
      this.action.present = true;

      this.tableModal = false;
    },

    onModalActionJoin() {
      this.action.target = this.selectedTable;
      this.action.type = "join";
      this.action.present = true;

      this.tableModal = false;
    },

    onModalMergeChecks() {
      const orders = this.$store.getters["queue/getSessionOrders"](
        this.selectedTable
      );

      // this.merge.active = true;
      // this.merge.orders = orders.slice();

      // this.tableModal = false;
      this.$router.push({
        name: "merge_action",
        params: {
          order_id: orders[0]._id,
        },
      });
    },

    onActionConfirm() {
      if (this.action.type === "move") {
        this.handleMoveAction();
        this.action.type = "empty";
      }
      if (this.action.type === "join") this.handleJoinAction();
    },

    onModalActionDisjoin() {
      this.$store
        .dispatch("queue/disjoinTables", {
          section: this.selectedTable.section,
          pair: this.selectedTable.tables,
        })
        .then((ok) => {
          this.tableModal = false;
        });
    },

    onMergeCancel() {
      this.merge.active = false;
    },

    onMergeConfirm(primary, secondary) {
      this.$store
        .dispatch("queue/mergeOrders", {
          primary,
          secondary,
        })
        .then((ok) => {
          this.merge.active = false;
        });
    },

    resetAction() {
      this.action.present = false;
      this.action.selection = null;
      this.action.target = null;
    },

    handleMoveAction() {
      const orders = this.$store.getters["queue/getSessionOrders"](
        this.action.target
      );

      this.$store
        .dispatch("queue/moveSession", {
          target: {
            //this is NOT action target, but target where TO move
            section: this.action.selection.section,
            table: this.action.selection.tables[0],
          },
          orders: orders.map((o) => o._id),
        })
        .then(this.resetAction);
    },

    handleJoinAction() {
      this.$store
        .dispatch("queue/joinTables", {
          section: this.action.target.section,
          pair: [this.action.target.tables[0], this.action.selection.tables[0]],
        })
        .then(this.resetAction);
    },

    navigateBackToMode(mode) {
      this.$router.push({
        name: "orders",
        query: {
          m: mode,
        },
      });
    },
  },
  mounted() {
    this.clientWidth = window.innerWidth;
    window.addEventListener("resize", this.handleResize);
    this.fetchOrders();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    isDesktop() {
      return this.clientWidth > 768;
    },
    tablesUi() {
      return this.$store.getters[`queue/tablesUi`];
    },
    cafe() {
      return this.$store.state.cafe;
    },
    formatModalAmount() {
      const amount = this.selectedTable.amount;

      if (amount == 1) {
        return `${amount} ${this.$t("tables.noun_checks.singular")}`;
      }

      if (amount < 5) {
        return `${amount} ${this.$t("tables.noun_checks.plural")}`;
      }

      if (amount > 5) {
        return `${amount} ${this.$t("tables.noun_checks.plural_2")}`;
      }
    },
    getCorrectBtnName() {
      if (this.action.type === "move")
        return `${this.$t("tables.titles.move")}`;
      if (this.action.type === "join")
        return `${this.$t("tables.titles.join")}`;
      return "";
    },
    getBtnColor() {
      if (this.action.type === "move") return "green-btn";
      if (this.action.type === "join") return "blue-btn";
      return "btn green-btn";
    },
  },
  components: {
    Navbar,
    MergeModal,
    NavbarDesktop,
    BottomNavbar,
  },
};
</script>
